'use strict'

import $ from 'jquery';

// prettier-ignore
//console.log('before news.js');
const news = () => {
    $(function() {
        //console.log('in news.js');
        let leftID = null;
        let rightID = null;
        let direction = '';
        const windowWidth = $(window).width();
        const marqueeContainer = $('.horizontally-scrolled-heading');
        const marquee = $('span.marquee.first');
        var marqueeWidth = Math.ceil($(marquee).outerWidth());
        var marqueeContent = marquee.html();
        var spansPerPage = Math.ceil(windowWidth / marqueeWidth);

        // append one less span to the container, because we already have one in it
        function appendMarquees() {
            for (let i = 0; i < spansPerPage - 1; i++) {
                marquee.html(marquee.html() + ' ' + marqueeContent);
            }
            marqueeWidth = Math.ceil($(marquee).outerWidth());
            marqueeContent = marquee.html();
            spansPerPage = Math.ceil(windowWidth / marqueeWidth);
        }
        appendMarquees();

        const pixelsPerSecond = 1;
        const spanTemplate = '<span class="title marquee">' + marqueeContent + '</span>';
        const positionsArr = [];
        let marqueesCollection = [];
        const requestAnimationFrame = window.requestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.msRequestAnimationFrame;

        //console.log(marqueeWidth);


        // starting positions for each span
        function initStartingPositions() {
            for (let i = 0; i < spansPerPage; i++) {
                positionsArr.push(marqueeWidth * i);
            }
        }

        function getCurrentPosition(element) {
            let matrix = $(element).css('transform').replace(/[^0-9\-.,]/g, '').split(',');
            let x = matrix[12] || matrix[4];
            return x;
        };



        // select all spans
        marqueesCollection = $('span.marquee');

        initStartingPositions();

        function animateLeftToRight() {
            for (let i = 0; i < positionsArr.length; i++) {
                positionsArr[i] += pixelsPerSecond;
                if (positionsArr[i] >= 0) {
                    positionsArr[i] = 0;
                }
                $(marqueesCollection[i]).css('-webkit-transform', 'translateX(' + positionsArr[i] + 'px)');
            }
            rightID = requestAnimationFrame(animateLeftToRight);
        }

        // on load text is animated left to right
        animateLeftToRight();
        direction = 'right';

        function animateRightToLeft() {
            for (let i = 0; i < Math.min(positionsArr.length, marqueeWidth); i++) {
                positionsArr[i] -= pixelsPerSecond;
                if (positionsArr[i] + marqueeWidth < windowWidth) {
                    positionsArr[i] = windowWidth - marqueeWidth;
                }
                $(marqueesCollection[i]).css('-webkit-transform', 'translateX(' + positionsArr[i] + 'px)');
            }
            leftID = requestAnimationFrame(animateRightToLeft);
        }

        // on mouse wheel scroll - change directions
        let lastY = 0;
        $(window).on('touchmove wheel', function(event) {
            //console.log('in on.wheel');
            // get current postions for each span
            for (let i = 0; i < positionsArr.length; i++) {
                positionsArr[i] = parseInt(getCurrentPosition($(marqueesCollection[i])))
            }

            //console.log(event.type);
            let delta = 0;
            if (event.type == 'touchmove') {
                var currentY = event.originalEvent.touches[0].clientY;
                if (currentY > lastY) {
                    delta = -1;
                } else if (currentY < lastY) {
                    delta = 1;
                }
                lastY = currentY;
                //console.log(delta);
            } else {
                delta = event.originalEvent.deltaY;
                //console.log(delta);
            }
            if (delta > 0) {
                // downscroll code
                if (direction === 'left') {
                    return;
                }
                window.cancelAnimationFrame(rightID);
                //console.log('left');
                animateRightToLeft();
                direction = 'left';

            } else {
                // upscroll code
                if (direction === 'right') {
                    return
                }
                window.cancelAnimationFrame(leftID);
                //console.log('right');
                animateLeftToRight();
                direction = 'right';
            }
        });

    });
};

export default news;


// WEBPACK FOOTER //
// ./src/scripts/modules/news.js